import React, { useState, useEffect, useRef, useCallback } from "react";

const buildSrc = (videoId, isPlaying, isMuted, startTime) =>
  `https://www.youtube.com/embed/${videoId}?autoplay=${isPlaying ? 1 : 0}&mute=${isMuted ? 1 : 0}&loop=1&playlist=${videoId}&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1&disablekb=1&fs=0&iv_load_policy=3&enablejsapi=1&start=${startTime}&origin=${window.location.origin}`;

const VideoBackground = ({
  videoId = 'liFjsSDj1eM',
  startTime = 10,
  isPlaying = true,
  isMuted = true,
  volume = 0
}) => {
  const [displayedId, setDisplayedId] = useState(videoId);
  const [incoming, setIncoming] = useState(null);
  const newRef = useRef(null);

  useEffect(() => {
    if (videoId !== displayedId) {
      setIncoming({ id: videoId });
    }
  }, [videoId, displayedId]);

  const handleNewLoad = useCallback(() => {
    const el = newRef.current;
    if (el) void el.getBoundingClientRect();
    setIncoming(prev => (prev ? { ...prev, loaded: true } : prev));
  }, []);

  useEffect(() => {
    if (!incoming?.loaded) return;
    const timer = setTimeout(() => {
      setDisplayedId(incoming.id);
      setIncoming(null);
    }, 800);
    return () => clearTimeout(timer);
  }, [incoming]);

  if (!videoId) return null;

  const oldOpacity = incoming?.loaded ? 0 : 1;
  const newOpacity = incoming?.loaded ? 1 : 0;

  const iframeStyle = (opacity) => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "max(100vw, calc(100vh * 16 / 9))",
    height: "max(100vh, calc(100vw * 9 / 16))",
    minWidth: "100vw",
    minHeight: "100vh",
    border: "none",
    transform: "translate(-50%, -50%)",
    opacity,
    transition: "opacity 0.8s ease"
  });

  return (
    <div className="video-bg" style={{
      position: "fixed",
      top: 0, left: 0, right: 0, bottom: 0,
      zIndex: -2,
      overflow: "hidden",
      pointerEvents: "none"
    }}>
      {isPlaying && (
        <>
          {incoming && (
            <iframe
              ref={newRef}
              key={incoming.id}
              src={buildSrc(incoming.id, isPlaying, isMuted, startTime)}
              title={`Ambient background video ${incoming.id}`}
              allow="autoplay; encrypted-media"
              allowFullScreen={false}
              onLoad={handleNewLoad}
              style={iframeStyle(newOpacity)}
            />
          )}
          <iframe
            key={displayedId}
            src={buildSrc(displayedId, isPlaying, isMuted, startTime)}
            title={`Ambient background video ${displayedId}`}
            allow="autoplay; encrypted-media"
            allowFullScreen={false}
            style={iframeStyle(oldOpacity)}
          />
        </>
      )}
    </div>
  );
};

export default React.memo(VideoBackground);
